<template>
  <span class="fl" v-if="hasPermission">
    <slot></slot>
    </span>
</template>
<script>
import { mount } from 'sortablejs';

  export default {
     name: 'Permission',
    props: {
      code: {
        type: [Array,String],
        default:()=>{
          return [];
        }
      }

    },
    data() {
      return {
        hasPermission: false,
        resCode:[]
      }
    },
    mounted() {
      this.load(this.code);
    },

    methods: {
      load(code) {
        console.log("Permission updated",code);
        if(code){
          if(typeof code=='string'){
            this.resCode = code.split(',');
          }else{
            this.resCode = code;
          }
          var user = JSON.parse(localStorage.getItem("login"));

          console.log(user.userType);
          // if(user.userType == 3){
          //   this.hasPermission = true;
          //   return
          // }
          this.hasPermission = this.check();
        }else{
          this.hasPermission = true;
        }
      },
      check (){
        console.log("check permission");
        var codes = this.resCode;
        var userInfo = this.$store.state.sharing.userInfo;
        if (!userInfo) {
          userInfo = localStorage.getItem("login");
          userInfo = userInfo ? JSON.parse(userInfo) : {}
        }
        var userType = userInfo.userType;
        var hasPermission = userType==1 || false;
        if(!hasPermission){
          for(var i=0;i<codes.length;i++){
            var code = codes[i];
            if(code.charAt(0)==userType){
              hasPermission = true;
              break;
            }
          }
        }
        if(!hasPermission){
          return false;
        }

        var btns = userInfo.attrs.btns || [];
        var isAdmin = userInfo.attrs.isAdmin && userType == 1 || false;
        var hasPermission = isAdmin || codes.length==0;
        if (!hasPermission) {
          for (var i = 0; i < btns.length; i++) {
            for(var j=0;j<codes.length;j++){
              var code = codes[j];
              if (code == btns[i]) {
                hasPermission = true;
                break;
              }
            }
          }
        }
        return hasPermission;
      }
    },
  };
</script>
<style scoped>
.fl{
  float: left;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/permission.vue